module.exports = __webpack_public_path__ + "static/media/banner.98294d17.jpg";